import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Cards from '../../assets/cards/cards';
import { ReactComponent as Back } from '../../assets/icons/back.svg';
import { ReactComponent as Distance } from '../../assets/icons/intro/scanning.svg';
import { ReactComponent as Scanner } from '../../assets/icons/scanner.svg';
import BottomSheet from '../../components/bottomsheet/BottomSheet';
import PrimaryButton from '../../components/buttons/primarybutton/PrimaryButton';
import PrimaryIconButton from '../../components/buttons/primaryiconbutton/PrimaryIconButton';
import Card from '../../components/card/Card';
import FeedbackButton from '../../components/feedbackbutton/FeedbackButton';
import Hints from '../../components/hints/Hints';
import H1 from '../../components/text/H1';
import TradingView from '../../components/tradingview/TradingView';
import { tag } from '../../services/ATInternetService';
import { getCollectedCardIds, getCollectionCount, getSortedCollection, isCardInCollection, saveCollection } from '../../stored/Collection';
import { hasUserAction } from '../../stored/UserActions';
import CardView from '../cardview/CardView';
import Page from '../Page';
import './Collection.sass';

const Collection = ({ onRequestHideCollection, tradeQRCode }) => {
	const [showCardViewCard, setShowCardViewCard] = useState(undefined);
	const [showTradingView, setShowTradingView] = useState(tradeQRCode !== null);
	const [collection, setCollection] = useState(getSortedCollection());
	const [tradeData, setTradeData] = useState(tradeQRCode);

	useEffect(() => { }, [collection, showCardViewCard, showTradingView, tradeData]);

	useEffect(() => {
		if (!showCardViewCard) {
			setCollection(getSortedCollection());
		}
	}, [showCardViewCard]);

	if (showCardViewCard) return <CardView
		card={showCardViewCard}
		onBackPressed={() => {
			setShowCardViewCard(undefined);
		}}
		openCollection={() => {
			setShowCardViewCard(undefined);
		}}
	/>;

	if (getCollectionCount() < 1) {
		return <Page className="flex flex-col">
			<div className="flex-grow" onClick={onRequestHideCollection} />
			<BottomSheet
				padding
				color="#45AFA7"
				allowOverflow
				primaryButton={
					<PrimaryButton
						animated
						onClick={() => {
							onRequestHideCollection();
							tag.sendClick('collection', {
								name: 'closed-collection',
							});
						}}
						className="absolute -top-8 left-4 flex flex-row"><Scanner className="mr-2 -ml-4" /><span className="-mr-2">Scanner</span>
					</PrimaryButton>
				}>
				<div className="overflow-y-auto pb-12" style={{ maxHeight: '80vh' }}>
					<div className="flex flex-row content-end pt-8">
						<H1>{getCollectionCount() > 0 ? 'Verzameling' : 'Tips'}</H1>
						<div className="inline-block bg-white text-black max-h-8 font-bold text-lg rounded-full px-3 align-middle leading-8 shadow-md">
							0 kaarten verzameld
						</div>
					</div>
					<p className="text-center font-bold bg-white bg-opacity-10 p-8 rounded-xl mt-4">
						Je vindt de kleine organismen in je huis met de scanner, bijvoorbeeld in de woonkamer of in je slaapkamer!
					</p>
					<div className="my-4 bg-black bg-opacity-50 py-4 rounded-xl shadow-md overflow-hidden">
						<div className="-mx-4">
							<Distance className="distance__animation" />
						</div>
					</div>
					<p className="text-center font-bold bg-white bg-opacity-10 p-8 rounded-xl">
						Hou tijdens het scannen voldoende afstand. Minimaal 1 meter is goed!
					</p>
					<div className="my-4 bg-black bg-opacity-50 py-4 rounded-xl shadow-md overflow-hidden">
						<div className="-mx-4">
							<Hints />
						</div>
					</div>
					<p className="text-center font-bold bg-white bg-opacity-10 p-8 rounded-xl">
						Hier vind je jouw verzameling van de Klokhuis Scanner terug. Ontgrendel een kaart om deze toe te voegen aan je verzameling.
					</p>
				</div>
			</BottomSheet>

			{showTradingView && <TradingView
				onClosed={() => {
					setShowTradingView(false);
					setCollection(getSortedCollection());
					setTradeData(null);
				}}
				tradeQRCode={tradeData}
			/>}
		</Page>;
	}
	return <Page className="flex flex-col">
		<div className="flex-grow">
			<PrimaryIconButton
				className="absolute top-6 left-6"
				onClick={onRequestHideCollection}
				animated>
				<Back />
			</PrimaryIconButton>
			{getCollectionCount() > 1 && <PrimaryButton
				className="absolute top-6 right-6"
				onClick={() => {
					setShowTradingView(true);
					tag.sendClick('collection', {
						name: 'opened-trading',
					});
				}}
				animated>
				Ruilen
			</PrimaryButton>}
		</div>
		<BottomSheet>
			<div className="collection__background overflow-hidden">
				<div className="flex flex-row content-end px-6 pt-6">
					<H1 xl shadow className="text-white">Verzameling</H1>
					<div className="inline-block bg-accent-500 text-white max-h-8 font-bold text-lg rounded-full px-3 align-middle leading-8 shadow-md">
						{getCollectedCardIds().size}/{Cards.length}
					</div>
				</div>
				<div className="overflow-y-hidden overflow-x-scroll">
					<div className="flex flex-row min-w-min py-4" style={{ height: '60vh', maxHeight: '26rem' }}>
						<div className="w-3" />
						{collection.map((card) => <Card
							key={card.id}
							cardId={card.cardId}
							foundAt={card.atPlace}
							score={card.score}
							showOpenCardHint
							onClick={() => {
								tag.sendClick('collection', {
									chapter3: card.cardId,
									name: 'opened-card',
								});
								setShowCardViewCard(card);
							}}
						/>)}
						{!hasUserAction('feedback:feedback-button-pressed') && <div className="text-white mr-6 -mt-3 overflow-hidden w-64 flex flex-col overflow-y-scroll justify-between">
							<img src="/klokhuisscanner/logo192.png" alt="Logo" className="flex-shrink object-contain max-h-24 px-4 pt-4" />
							<p className="p-4 font-bold filter drop-shadow-lg text-center">
								Wil je ons helpen de Klokhuis Scanner nog beter te maken? Tik hieronder om je mening te geven!
							</p>
							<FeedbackButton className="w-full bg-accent-600 rounded-3xl" />
						</div>}
						{Cards.map((card) => {
							if (!isCardInCollection(card.id)) {
								return <Card key={card.id} />;
							}
							return <></>;

						})}
						<div className="w-4" />
						{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
						{!/hetklokhuis/.test(window.location.href) && <a
							href="#"
							className="self-center text-red-500 px-8 underline"
							onClick={() => {
								// eslint-disable-next-line no-restricted-globals, no-alert
								if (confirm('Weet je zeker dat je al je kaarten wilt wissen?')) {
									saveCollection([]);
									onRequestHideCollection();
								}
							}}>Wis mijn verzameling (VOOR TESTEN)
						</a>}
						<div className="w-4" />
					</div>
				</div>
			</div>
		</BottomSheet>

		{showTradingView && <TradingView
			onClosed={() => {
				setShowTradingView(false);
				setCollection(getSortedCollection());
				setTradeData(null);
			}}
			tradeQRCode={tradeData}
		/>}
	</Page>;

};

Collection.propTypes = {
	onRequestHideCollection: PropTypes.func.isRequired,
	tradeQRCode: PropTypes.any
}

Collection.defaultProps = {
	tradeQRCode: undefined
}

export default Collection;
